/**
 * TutorialStep model
 * Defines the shape of a single step in the interactive onboarding tutorial.
 */
export class TutorialStep {
  constructor({
    id,
    targetSelector,
    message,
    buttonText = null,
    advanceOn = 'button', // 'button' | 'natural-click'
    route,               // route prefix to match (e.g. '/home', '/prompt/')
    navigateAfter = null, // route to programmatically navigate to after this step completes
    preferPlacement = null, // 'above' | 'below' to force tooltip placement
    analyticsEvent,
  }) {
    this.id = id;
    this.targetSelector = targetSelector;
    this.message = message;
    this.buttonText = buttonText;
    this.advanceOn = advanceOn;
    this.route = route;
    this.navigateAfter = navigateAfter;
    this.preferPlacement = preferPlacement;
    this.analyticsEvent = analyticsEvent;
  }
}
